/**
 * @group Enums
 * @summary Re-exports EHR_PROVIDERS from @shared/constants for backward compatibility.
 */
export { EHR_PROVIDERS } from '@shared/constants';
